<template>
  <div class="intro">
    <simple-search class="search-entry"
      placeholder="Enter your postal code or constituency"
      @select="onConstituencySelect"></simple-search>
    <div class="component-bullets">
      <bullets :attributes="{text: attributes.value.bullets, liststyletype: 'disc'}"/>
      <bullets v-if="secondBullet" :attributes="{text: [secondBullet], liststyletype: 'disc'}"/>
      <bullets :attributes="{text: decks, liststyletype: 'disc', class: 'dynamic-bullet'}"/>
    </div>
    <!-- <div class="happening-title">
      <h2 v-if="eventsTodayCtr">Happening now</h2>
      <h2 v-if="!eventsTodayCtr && eventsTomorrowCtr">Happening tomorrow</h2>
    </div> -->
  </div>
</template>

<script>
import $ from 'jquery'
import {mapState} from 'vuex'
import Bullets from '../../Bullets'
import SimpleSearch from './SimpleSearch.vue'
import {store} from '../store-constituency'
import _find from 'lodash/find'
import projectMixin from '../projectmixin.js'

export default {
  props: ['attributes'],
  mixins: [projectMixin],
  components: {
    Bullets,
    SimpleSearch
  },
  computed: {
    ...mapState(['eventsconstituencies', 'eventsdata']),
    secondBullet: function () {
      var txt = "There {{numhappeningnowempty: is: are}} {{numhappeningnow: event: events}} happening **right now**, {{numtoday: event: events}} **today**, and {{numtomorrow: event: events}} **tomorrow**."
      if (store.currentConstituency) {
        txt = ''
      }
      return this.$replaceVar(txt).replace('is zero event', 'are no events').replace('zero event', 'no events')
    }
  },
  data () {
    return {
      currentData: {},
      decks: [],
      eventsTodayCtr: 0,
      eventsTomorrowCtr: 0
    }
  },
  methods: {
    onConstituencySelect (constituency) {
      this.$el.querySelector('ul.dynamic-bullet').style.opacity = 0

      if (constituency && constituency.name) {
        store.currentConstituency = constituency && store.constituencies[constituency.name]
        this.getOtherPar()
        this.showAndscrollNow()
        if (store.constituencies[constituency.name]) {
          this.$analytics.getClient('ge-calendar-2020').track(`search`, constituency.name)
        }
      } else {
        store.currentConstituency = constituency
        this.decks = []
      }
    },
    showAndscrollNow () {
      $(this.$el.querySelector('ul.dynamic-bullet')).animate({
        opacity: 1
      }, 800)
      $('html, body').animate({
        scrollTop: $('.component.component-intro').offset().top
      }, 500, 'linear')
      return false
    },
    getOtherPar () {
      if (store.currentConstituency) {
        this.decks = []
        var typeStr = store.currentConstituency.typeString
        typeStr = typeStr.slice(typeStr.length - 3)
        var par1 = `In **${store.currentConstituency.name} ${typeStr}**,`
        var par2 = 'there are no events today.'
        var par3 = ''
        var todayCtr = 0
        var tomorrowCtr = 0
        var nextCtr = 0
        var nextDateStr = ''
        var nextDiffDays = ''

        this.eventsdata.forEach((element, i) => {
          if (element.constituency && element.constituency.includes(store.currentConstituency.name)) {
            if (element.noun === 'happening now' || element.noun === 'today') {
              todayCtr++
            } else if (element.noun === 'tomorrow') {
              tomorrowCtr++
            } else if (new Date(element.end) > new Date()) {
              if (!nextDateStr) {
                nextDateStr = element.daystring

                const start = (new Date(element.start)).setHours(0, 0, 0, 0)
                const now = (new Date()).setHours(0, 0, 0, 0)
                nextDiffDays = parseInt((start - now) / (1000 * 60 * 60 * 24), 10)
              }
              nextCtr++
            }
          }
        })

        this.eventsTodayCtr = todayCtr
        this.eventsTomorrowCtr = tomorrowCtr

        if (todayCtr) {
          par2 = `there ${todayCtr > 1 ? 'are' : 'is'} ${todayCtr} event${todayCtr > 1 ? 's' : ''} today.`
        }
        if (tomorrowCtr) {
          par3 = `The next event is tomorrow.`
        } else if (nextCtr) {
          par3 = `The next event is in ${this.$numWordAuto(nextDiffDays)} day${nextDiffDays > 1 ? 's' : ''} on ${nextDateStr}`
        } else if (!todayCtr) {
          par3 = 'The next event is not yet scheduled.'
        }

        this.decks.push(`${par1} ${par2} ${par3}`)
        this.getLastPar()
      }
    },
    getLastPar () {
      if (store.currentConstituency) {
        const found = _find(this.eventsconstituencies, {constituency: store.currentConstituency.name})
        this.currentData = found
        if (found && found['contesting-short']) {
          this.decks.push(found['contesting-short'])
        }
      }
    }
  }
}
</script>

<style lang="scss">
.intro {
  .search-entry {
    text-align: center;
    margin: 0 auto;
    box-sizing: border-box;
    width: 100%;
    max-width: 300px;
    padding-bottom: 35px;
  }
  .happening-title {
    padding-top: 20px;
  }
  ul {
    padding-top: 17px;
    li:last-child {
      padding-top: 0;
    }
  }
  ul li strong {
    font-family: $font-SelaneFifty;
    font-size: 20px;
    font-weight: unset;
  }
}
</style>
